import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the TextpartsProvider provider.

  See https://angu  getNumeral: any;
lar.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class TextProvider {

  constructor(public http: Http) {
    // console.log('Hello TextProvider Provider');
  }

//https://www.kirupa.com/html5/picking_random_item_from_array.htm


/**Liefert eine zufällige Antwort aus correctAnswers Liste
 * 
 * 
 * @readonly
 * @type {string} 
 * @memberof TextProvider
 */
public get getCorrectAnswer():string{
var answer = this.correctAnswers[Math.floor(Math.random()*this.correctAnswers.length)];

return answer;

}


/**Liefert eine zufällige Antwort aus wrongAnswers Liste
 *
 * 
 * @readonly
 * @type {string}
 * @memberof TextProvider
 */
public get getWrongAnswer():string{
var answer = this.wrongAnswers[Math.floor(Math.random()*this.wrongAnswers.length)];

return answer;

}

//todo die funktion von Amelies win10 hier umsetzen
NumberToNumeral(num:number):string{
  let numerale:string[] = ['null', 'eins', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun', 'zehn', 'elf', 'zwölf', 'dreizehn', 'vierzehn', 'fünfzehn', 'sechzehn', 'siebzehn', 'achtzehn', 'neunzehn']
var answer = numerale[num];

return answer;

}

/**Liste mit richtigen Antworten
 *
 * 
 * @type {string[]}
 * @memberof TextProvider
 */
correctAnswers: string[] = [
  'Super',
  'Klasse',
  'Weiter so',
  'Richtig',
  'Die Antwort ist richtig'
];


/**Liste mit falschen Antworten
 *
 * 
 * @type {string[]}
 * @memberof TextProvider
 */
wrongAnswers: string[] = [
  'Leider falsch',
  'Probiere es noch einmal',
  'Die Antwort ist falsch',
  'Nicht richtig',
  'Stimmt nicht'
];

}



// WEBPACK FOOTER //
// ./src/providers/text/text.ts